import { useEffect } from "react";
import "@/App.css";
import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { About } from "@/components/landing/About";
import { Services } from "@/components/landing/Services";
import { EyeExam } from "@/components/landing/EyeExam";
import { LocationSection } from "@/components/landing/LocationSection";
import { FinalCta, Footer } from "@/components/landing/Footer";
import { FloatingWhatsApp } from "@/components/landing/FloatingWhatsApp";
import { Videos } from "@/components/landing/Videos";
import { Reviews } from "@/components/landing/Reviews";
import { Gallery } from "@/components/landing/Gallery";

function App() {
  useEffect(() => {
    const elements = document.querySelectorAll("[data-reveal]");
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      elements.forEach((el) => el.classList.add("is-visible"));
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="min-h-screen bg-white font-body text-stone-900 antialiased">
      <Header />
      <main>
        <Hero />
        <About />
        <Gallery />
        <Services />
        <Videos />
        <EyeExam />
        <Reviews />
        <LocationSection />
        <FinalCta />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}

export default App;
